"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _renderprops = require("react-spring/renderprops");

var _createStyled = _interopRequireDefault(require("../../utils/createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    box-sizing: border-box;\n    visibility: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var STATE_LEAVE = 'leave';

var ConstraintsHolder = _createStyled["default"].div(_templateObject());

var AnimateHeight =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(AnimateHeight, _React$PureComponent);

  function AnimateHeight(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateHeight);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AnimateHeight).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleRest", function (open, state) {
      var onRest = _this.props.onRest;

      if (_this.isTransitionWithoutUnmount()) {
        _this.setState({
          rest: _this.props.open,
          animating: false
        });
      } else if (open) {
        _this.setState({
          rest: state !== STATE_LEAVE,
          animating: false
        });
      }

      if (typeof onRest === 'function') {
        for (var _len = arguments.length, other = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          other[_key - 2] = arguments[_key];
        }

        onRest.apply(void 0, [open, state].concat(other));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleStart", function (open) {
      var onStart = _this.props.onStart;

      if (_this.isTransitionWithoutUnmount() || open) {
        _this.setState({
          rest: false,
          animating: true
        });
      }

      if (typeof onStart === 'function') {
        for (var _len2 = arguments.length, other = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          other[_key2 - 1] = arguments[_key2];
        }

        onStart.apply(void 0, [open].concat(other));
      }
    });
    _this.state = {
      mounted: false,
      // rest in opened state
      rest: false,
      animating: false
    };
    _this.root = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(AnimateHeight, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "isTransitionWithoutUnmount",
    value: function isTransitionWithoutUnmount() {
      return this.props.minHeight > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          open = _this$props.open,
          minHeight = _this$props.minHeight,
          children = _this$props.children,
          config = _this$props.config,
          onFrame = _this$props.onFrame,
          onDestroyed = _this$props.onDestroyed,
          enter = _this$props.enter,
          leave = _this$props.leave,
          from = _this$props.from,
          to = _this$props.to,
          keys = _this$props.keys,
          _this$state = this.state,
          mounted = _this$state.mounted,
          rest = _this$state.rest,
          animating = _this$state.animating;
      var transition = null;

      if (mounted) {
        var content = function content(props) {
          var _this2$root$current;

          return _react["default"].createElement("div", {
            style: {
              /*
               * fix #1: width detection with flex displayed content.
               * fix #2: overflow hidden on completed animation is unnecessary
               * */
              width: rest ? 'auto' : (_this2$root$current = _this2.root.current) === null || _this2$root$current === void 0 ? void 0 : _this2$root$current.offsetWidth,
              overflow: _this2.isTransitionWithoutUnmount() ? rest ? 'visible' : 'hidden' : animating ? 'hidden' : 'visible'
            }
          }, _react["default"].createElement(_renderprops.animated.div, {
            style: props
          }, children));
        };

        if (this.isTransitionWithoutUnmount()) {
          transition = _react["default"].createElement(_renderprops.Spring, {
            from: _objectSpread({}, from, {
              height: minHeight
            }),
            to: _objectSpread({}, to, {
              height: open ? "auto" : minHeight
            }),
            config: config,
            "native": true,
            onStart: this._handleStart,
            onRest: this._handleRest,
            onFrame: onFrame,
            unique: true
          }, content);
        } else {
          transition = _react["default"].createElement(_renderprops.Transition, {
            items: open,
            keys: keys,
            from: from,
            enter: enter,
            leave: leave,
            config: config,
            "native": true,
            onStart: this._handleStart,
            onRest: this._handleRest,
            onFrame: onFrame,
            onDestroyed: onDestroyed,
            unique: true
          }, function (active) {
            return active && content;
          });
        }
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(ConstraintsHolder, {
        ref: this.root
      }), transition);
    }
  }]);
  return AnimateHeight;
}(_react["default"].PureComponent);

AnimateHeight.propTypes = {
  /** open/close flag */
  open: _propTypes["default"].bool,

  /** minimal height of content */
  minHeight: _propTypes["default"].number,
  children: _propTypes["default"].any,

  /** react-spring config */
  config: _propTypes["default"].object,

  /** react-spring onStart */
  onStart: _propTypes["default"].func,

  /** react-spring onRest */
  onRest: _propTypes["default"].func,

  /** react-spring onFrame */
  onFrame: _propTypes["default"].func,

  /** react-spring onDestroyed */
  onDestroyed: _propTypes["default"].func,

  /** react-spring enter */
  enter: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool]),

  /** react-spring leave */
  leave: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool]),

  /** react-spring from. only if minHeight > 0 */
  from: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool]),

  /** react-spring to. only if minHeight > 0 */
  to: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool]),
  keys: _propTypes["default"].any
};
AnimateHeight.defaultProps = {
  open: true,
  minHeight: 0,
  enter: {
    height: 'auto'
  },
  leave: {
    height: 0
  },
  from: {
    height: 0
  }
};
var _default = AnimateHeight;
exports["default"] = _default;